import { createAction, props } from '@ngrx/store';
import { IFlight } from '../../../../model/flights';

export const requestFlights = createAction('[Flights] Request Flights', props<{ centerlineIds: string[] }>());
export const loadFlights = createAction('[Flights Effects] Load Flights', props<{ flights: IFlight[] }>());
